//** Import Modules */
import React, { useState } from "react";
import { Button, Grid, Tooltip } from "antd";
import EventTicketForm from "./EventTicketForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

export default function EditEventTicketBtn(props) {
  const { event, editedData, getTicketData } = props;

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [isModalVisible, setIsModalVisible] = useState(false);

  // Modal handlers
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      {/* <button onClick={showModal}>Edit</button> */}

      {screens.md ? (
        <button onClick={showModal}>
          <Tooltip title="Edit">
            <FontAwesomeIcon icon={faEdit} />
          </Tooltip>
        </button>
      ) : (
        <Button onClick={showModal}>
          <Tooltip title="Edit">
            <FontAwesomeIcon icon={faEdit} />
          </Tooltip>
        </Button>
      )}

      <EventTicketForm
        event={event}
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
        editedData={editedData}
        getTicketData={getTicketData}
      />
    </>
  );
}
